import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(app-view)/registrant/registration/_client-page.tsx");
